import axios from "@/api/index";
let method = 'GET';
/*银企直贷--银企服务列表（分页版本）*/
export const yqzdServicePageList=data=>axios.post('/home/rest/RevisionOneGoods/yqzdServicePageList',data)
/*银企直贷--当前节点的银企(金融机构数量、放款金额 、金融产品)统计*/
export const yqzdShopStatistics=data=>axios.post('/home/rest/RevisionOneGoods/yqzdShopStatistics',data)
/*服务平台首页 -- 关于平台*/
export const aboutPlatform=data=>axios.post('/home/restPlatformHome/aboutPlatform',data)
/*银企直贷--产品详情*/
export const yqzdGoodsInfo=data=>axios.post('/home/rest/RevisionOneGoods/yqzdGoodsInfo',data)
/*银企直贷--申请贷款*/
export const yqzdApplyLoans=data=>axios.post('/home/rest/RevisionOneGoods/yqzdApplyLoans',data)